import React from 'react';
import styled from 'styled-components';
import { Alert } from 'antd';

export const Notification = styled(({ ...props }) => <Alert message={props.children} {...props} />)`
  position: fixed;
  top: 6rem;
  white-space: pre-line;
  z-index: 10;
  border-radius: 0.25rem;

  &.ant-alert.ant-alert-closable {
    padding-right: 3rem;

    & .ant-alert-close-icon {
      right: 1rem;
    }
  }
`;
